export default __webpack_public_path__ + "static/media/Now Die.37b86de3.png";